import LampModuleIcon from './component'

export default LampModuleIcon
